module.exports = __webpack_public_path__ + "src/assets/img/contact_header.9462a314.jpg";